import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { MultiLineEllipsisText } from '@bingads-webui-react/multiline-ellipsis';

import { AdsLabel } from './ads-label';

import { getDescriptionStyles } from './styles/description';
import { getFinalUrlStyles } from './styles/final-url';
import { getLongHeadlineStyles } from './styles/long-headline';
import { getShortHeadlineStyles } from './styles/short-headline';

const TextContainer = React.forwardRef(({
  className,
  showMultiline,
  text,
}, ref) => (
  showMultiline ?
    <MultiLineEllipsisText
      ref={ref}
      className={className}
      text={text}
    /> : (
      <div className={className}>
        {text}
      </div>
    )
));

TextContainer.propTypes = {
  className: PropTypes.string.isRequired,
  showMultiline: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
};

export const Description = React.forwardRef(({
  styleOverrides,
  showMultipleDescription,
  description,
  showAdsLabel,
  adsLabelText,
}, ref) => {
  const classes = useDefaultStyles(getDescriptionStyles({ styleOverrides }));

  return (
    <div className={classnames('description-parent', classes.descriptionParent)}>
      {
        showAdsLabel &&
        <AdsLabel
          adsLabelText={adsLabelText}
          styleOverrides={styleOverrides}
        />
      }
      <TextContainer
        ref={ref}
        showMultiline={showMultipleDescription}
        className={classnames('description', classes.description)}
        text={description}
      />
    </div>
  );
});

Description.propTypes = {
  showMultipleDescription: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  showAdsLabel: PropTypes.bool,
  adsLabelText: PropTypes.string,
  styleOverrides: PropTypes.shape({}),
};

Description.defaultProps = {
  styleOverrides: {},
  showAdsLabel: false,
  adsLabelText: '',
};


export const FinalUrl = React.forwardRef(({
  styleOverrides,
  showUrlMultiline,
  finalUrl,
  displayUrl,
}, ref) => {
  const classes = useDefaultStyles(getFinalUrlStyles({ styleOverrides }));

  return (
    <TextContainer
      ref={ref}
      showMultiline={showUrlMultiline}
      className={classnames('final-url', classes.finalUrl)}
      text={displayUrl || finalUrl}
    />
  );
});

FinalUrl.propTypes = {
  showUrlMultiline: PropTypes.bool.isRequired,
  finalUrl: PropTypes.string.isRequired,
  displayUrl: PropTypes.string,
  styleOverrides: PropTypes.shape({}),
};

FinalUrl.defaultProps = {
  displayUrl: null,
  styleOverrides: {},
};

export const LongHeadline = React.forwardRef(({
  styleOverrides,
  showMultipleLineLongHeadline,
  longHeadline,
}, ref) => {
  const classes = useDefaultStyles(getLongHeadlineStyles({ styleOverrides }));

  return (
    <TextContainer
      ref={ref}
      showMultiline={showMultipleLineLongHeadline}
      className={classnames('long-headline', classes.longHeadline)}
      text={longHeadline}
    />
  );
});

LongHeadline.propTypes = {
  showMultipleLineLongHeadline: PropTypes.bool.isRequired,
  longHeadline: PropTypes.string.isRequired,
  styleOverrides: PropTypes.shape({}),
};

LongHeadline.defaultProps = {
  styleOverrides: {},
};

export const ShortHeadline = React.forwardRef(({
  styleOverrides,
  showShortHeadlineMultiline,
  shortHeadline,
}, ref) => {
  const classes = useDefaultStyles(getShortHeadlineStyles({ styleOverrides }));

  return (
    <TextContainer
      ref={ref}
      showMultiline={showShortHeadlineMultiline}
      className={classnames('short-headline', classes.shortHeadline)}
      text={shortHeadline}
    />
  );
});

ShortHeadline.propTypes = {
  showShortHeadlineMultiline: PropTypes.bool.isRequired,
  shortHeadline: PropTypes.string.isRequired,
  styleOverrides: PropTypes.shape({}),
};

ShortHeadline.defaultProps = {
  styleOverrides: {},
};
